/*
export function splitToEnumArray <T extends Record<string, number | string>>(value: string, enumType: T, splitChar: string = ","):T[] {
    if (!value) {
        return [];
    }
    return value.split(splitChar).map((val: string) => getEnumByValue(parseInt(val), enumType));
}
export function getEnumByValue <T extends Record<string, number | string>>(value: number | string, enumType: T): T {
    //@ts-ignore
    return enumType[Object.values(enumType).filter((val: number | string) => val == value)] as T;
}
*/

export function stringToNumberArray(value: string): number[] {
    if (!value) {
        return [];
    }
    return value.split(",").map(Number);
}
